// extracted by mini-css-extract-plugin
module.exports = {"overview":"overview--2914Y","overview_item":"overview_item--eV3Ib","active":"active--gqU-q"};